import React from 'react';

//Images
import img3 from '../../assets/productivityimg3.svg';
import img4 from '../../assets/productivityimg4.svg';
import img5 from '../../assets/productivityimg5.svg';
import img6 from '../../assets/productivityimg6.svg';
import img7 from '../../assets/productivityimg7.svg';
import img8 from '../../assets/productivityimg8.svg';
import img9 from '../../assets/productivityimg9.svg';
import img10 from '../../assets/productivityimg10.svg';
import img11 from '../../assets/productivityimg11.svg';
import img12 from '../../assets/productivityimg12.svg';
import img13 from '../../assets/productivityimg13.svg';
import img14 from '../../assets/productivityimg14.svg';
import img15 from '../../assets/productivityimg15.svg';
import img16 from '../../assets/productivityimg16.svg';
import img17 from '../../assets/productivityimg17.svg';
import img18 from '../../assets/productivityimg18.svg';
import img19 from '../../assets/productivityimg19.svg';
import img20 from '../../assets/productivityimg20.svg';
import img21 from '../../assets/productivityimg21.svg';
import img22 from '../../assets/productivityimg22.svg';
import img23 from '../../assets/productivityimg23.svg';
import img24 from '../../assets/productivityimg24.svg';
import img25 from '../../assets/productivityimg25.svg';
import img26 from '../../assets/productivityimg26.svg';

//CSS File
import './effortlessIntegrations.css';

const EffortlessIntegrations = () => {

    return (

        <section className='effortless-integrations'>

            <div className='effortless-integrations-content'>

                <h1>Effortless <span>Integrations</span></h1>

                <p>Easily connect tools, databases, or import files with just a few clicks. AssistAI seamlessly integrates with various platforms and file formats, ensuring a smooth experience.</p>

            </div>

            <h1>Elevate Your Productivity <span>to New Heights</span> </h1>

            <div className='productivity-cards fix'>

                <div className='productivity-card'>
                    <img src={img3} alt="Productivity 3" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img4} alt="Productivity 4" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img5} alt="Productivity 5" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img6} alt="Productivity 6" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img7} alt="Productivity 7" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img8} alt="Productivity 8" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img9} alt="Productivity 9" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img10} alt="Productivity 10" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img11} alt="Productivity 11" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img12} alt="Productivity 12" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img13} alt="Productivity 13" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img14} alt="Productivity 14" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img15} alt="Productivity 15" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img16} alt="Productivity 16" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img17} alt="Productivity 17" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img18} alt="Productivity 18" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img19} alt="Productivity 19" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img20} alt="Productivity 20" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img21} alt="Productivity 21" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img22} alt="Productivity 22" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img23} alt="Productivity 23" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img24} alt="Productivity 24" />
                    <h2>Smart Helper</h2>
                    <p>Your assistant learns from your responses and grows more intelligent, evolving into your ultimate know-it-all helper.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img25} alt="Productivity 25" />
                    <h2>Skilled Companion</h2>
                    <p>Save time with automated information retrieval, eliminating the need for manual searches or team inquiries.</p>
                </div>

                <div className='productivity-card'>
                    <img src={img26} alt="Productivity 26" />
                    <h2>Service Bot</h2>
                    <p>Link integrations, sync spreadsheets, or upload documents to instantly engage with the chatbot.</p>
                </div>

            </div>

        </section>

    )

}

export default EffortlessIntegrations;